import { h } from 'preact';
import useInView from 'utils/in-view';
import { useMemo } from 'preact/hooks';
import { decodeId } from 'utils/helpers';
import ProductForm from './product-form';
import ProductGallery from '../product-gallery/product-gallery';
import ProductShopTheLook from './product-shop-the-look';
import ProductShopTheLookVc from './product-shop-the-look-vc';
import ProductTabs from './product-tabs';
import ProductInfoPanel from '../product-info-panel/product-info-panel';
import { withProductContext } from './product-context';
import Reviews from './yotpo-reviews';
import ProductStore from './product-store';
import { LocationsContext } from '../store-locator/locations-context';
import StoreLocator from '../store-locator/store-locator';

const Product = ({ productState, productActions, data, storeLocatorData }) => {
  const [galleryContainer, galleryInView] = useInView();

  const { currentVariant, currentProduct, products, options, relatedProducts } =
    productState;

  const { setCurrentProduct, setCurrentVariant, setOptions } = productActions;

  const reviews = useMemo(
    () => <Reviews id={decodeId(currentProduct?.id, 'Product')} />,
    [currentProduct.id],
  );

  const handleProductChange = (product) => {
    setCurrentProduct({ ...product });
    document.dispatchEvent(
      new CustomEvent('productUpdated', {
        detail: product,
      }),
    );
  };

  return (
    <div className="product container !px-24 !block md:!grid !grid-cols-2 tablet:!flex gap-x-20 lc:lg:gap-x-40 ml:lg:gap-x-48 md:py-40">
      <div
        className="md:flex-1 min-w-0 -mx-24 md:mx-0 relative"
        ref={galleryContainer}
      >
        <ProductGallery
          currentVariant={currentVariant}
          currentProduct={currentProduct}
        />
      </div>
      <div className="tablet:w-[427px]">
        <ProductForm
          currentProduct={currentProduct}
          currentVariant={currentVariant}
          setCurrentVariant={setCurrentVariant}
          galleryInView={galleryInView}
          products={products}
          relatedProducts={relatedProducts}
          onProductChange={handleProductChange}
          options={options}
          setOptions={setOptions}
        />
        <ProductShopTheLook
          {...data}
          currentProduct={currentProduct}
        />
        <ProductShopTheLookVc
          {...data}
          currentProduct={currentProduct}
          abTestVersion="shop-the-look-version-c"
          pairsWithProducts = {data.pairsWithProducts}
        />
        <ProductInfoPanel
          currentProduct={currentProduct}
          currentVariant={currentVariant}
        />
        <LocationsContext
          currentVariant={currentVariant}
          currentProduct={currentProduct}
          {...storeLocatorData}
        >
          <ProductStore currentVariant={currentVariant} />
          <StoreLocator />
        </LocationsContext>
        <ProductTabs currentProduct={currentProduct} delivery={data.delivery} />
        {!!data.showReviews && reviews}
      </div>
    </div>
  );
};

export default withProductContext(Product);
